import { render, staticRenderFns } from "./Responsables.vue?vue&type=template&id=4b8f4c2a&"
import script from "./Responsables.vue?vue&type=script&lang=js&"
export * from "./Responsables.vue?vue&type=script&lang=js&"
import style0 from "./Responsables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports